import React, { useEffect, useState } from 'react';
import styles from './home.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { sectionImgShape, } from '../../../assets';
import { Hero, SectionFirst, SectionFive, SectionFourth, SectionSecond, SectionThird } from '../../components';
import { apiGetCareerListing } from '../../helpers/backend_helper';
import { useDispatch, useSelector } from "react-redux";
import { fetchOurWorkData } from "../../slice/homeSlice";
import { fetchWhatWeDoData } from "../../slice/whatWeDoSlice";
import { fetchConfigData } from '../../slice/configSlice';
import { useTranslation } from 'react-i18next';
import '../../../i18n';

gsap.registerPlugin(ScrollTrigger);
const initialCareerData = [];


const Home = () => {

    /*  const [careerData, setCareerData] = useState(initialCareerData);
     const [loading, setLoading] = useState(false);

     useEffect(() => {
         getCareerListing();
       }, []); */
    const [colors, setColors] = useState([]);
    const colorPalette = ['#000000', '#DD043E', '#3e5beb', '#CE1974', '#6652C4'];

    const dispatch = useDispatch();
    /* const { data: configData, loading, error } = useSelector((state) => state.config);
    const { data: faqData } = useSelector((state) => state.home);
    const { data: service } = useSelector((state) => state.whatWeDo); */

    const { config: { data: configData, loading, error }, home: { data: faqData }, whatWeDo: { data: service }, } = useSelector((state) => ({
        config: state.config,
        home: state.home,
        whatWeDo: state.whatWeDo,
    }));

    useEffect(() => {
        dispatch(fetchConfigData());
    }, [dispatch])

    useEffect(() => {
        console.log(' Config Data : ', configData);
        console.log(' Config Data : ', faqData);
        console.log(' Config Data : ', service);
    }, [configData])
    const { t, i18n } = useTranslation();
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang); // Change the current language
    };






    useEffect(() => {
        dispatch(fetchOurWorkData());
        dispatch(fetchWhatWeDoData());
    }, [dispatch]);

    // Log the data whenever it changes
    useEffect(() => {
        if (faqData.length > 0) {
            console.log("Career Data from Redux:", faqData);
        }
        if (service.length > 0) {
            console.log("service Data from Redux:", service);
            const generatedColors = service.map((_, index) => colorPalette[index % colorPalette.length]);
            setColors(generatedColors);
        }
    }, [faqData, service]);


    /*  const getCareerListing = async () => {
       setLoading(true);
       try {
         const response = await apiGetCareerListing();
         console.log('Career Listing : ', response.results.data);
         setCareerData(response.results.data);
         console.log('response.results.totalItems : ', response.results.totalItems);
        // setTotalRecords(response.results.totalItems);
       }
       catch (error) {
         console.log('Error fetching Career Listing : ', error);
       }
       finally {
         setLoading(false);
       }
     } */


    return (
        <>
            <section className={styles.heroSec}>

                <Hero />
                {/* <div
                            className={styles.OurserviceSec_lTitle}
                        >
                            <h3>{t('welcome_message')}</h3>
                        </div>

                <button onClick={() => changeLanguage('en')}>{t('language_switch')} (English)</button>
                <button onClick={() => changeLanguage('ar')}>{t('language_switch')} (Arabic)</button> */}
            </section>
            <section className={styles.serviceSec}>
                <SectionFirst configData={configData} />
            </section>
            <section className={styles.OurserviceSec}>
                <SectionSecond />
            </section>
            <section className={styles.workSec}>
                <SectionThird />
            </section>
            {/* <section className={styles.blogSec}>
                <SectionFourth />
            </section>
            <section className={styles.ideaSec}>
                <SectionFive />
            </section> */}
        </>
    );
};

export default Home;
